import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { polarisSettingsGlobalViewsDetailsRoute } from '@jira/router-routes__polaris-routes/src/polarisSettingsGlobalViewsDetailsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { polarisGlobalViewsSettingsDetailPageEntry } from './ui/settings/global-views/polarisGlobalViewsSettingsDetailPageEntry.tsx';

export const polarisSettingsGlobalViewsDetailsRouteEntry: Route = createEntry(
	polarisSettingsGlobalViewsDetailsRoute,
	() => ({
		isStrictModeEnabled: false,
		group: 'global-settings',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		entryPoint() {
			return polarisGlobalViewsSettingsDetailPageEntry;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
